'use client';

import { useStore } from '@/lib/store';
import { fmtMs } from '@/lib/fmt';
import { cn } from '@/lib/cn';

const VENUES = ['polymarket', 'kalshi'] as const;

function color(p95: number): string {
  if (p95 < 80) return 'text-ok';
  if (p95 < 150) return 'text-warn';
  return 'text-err';
}

export function LatencyStrip() {
  const connected = useStore((s) => s.connected);
  const latency = useStore((s) => s.latency);

  return (
    <footer className="border-t border-border px-3 py-1 flex items-center gap-4 text-xs bg-panel">
      <span className={cn(connected ? 'text-ok' : 'text-err')}>
        {connected ? '● connected' : '○ disconnected'}
      </span>
      {VENUES.map((v) => {
        const l = latency[v];
        if (!l) return (
          <span key={v} className="text-muted">
            {v}: <span className="font-mono">—/—</span>
          </span>
        );
        return (
          <span key={v} className="text-muted">
            {v}:{' '}
            <span className={cn('font-mono', color(l.p95))}>
              {fmtMs(l.p50)}/{fmtMs(l.p95)}
            </span>{' '}
            <span className="text-muted">(n={l.n})</span>
          </span>
        );
      })}
      <span className="ml-auto text-muted">p50/p95 ms · WS event age</span>
    </footer>
  );
}
